export default "__VITE_ASSET__BnY2Fzg8__"